import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=68ceec4c&"
import script from "./Projects.vue?vue&type=script&lang=js&"
export * from "./Projects.vue?vue&type=script&lang=js&"
import style0 from "./Projects.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68ceec4c')) {
      api.createRecord('68ceec4c', component.options)
    } else {
      api.reload('68ceec4c', component.options)
    }
    module.hot.accept("./Projects.vue?vue&type=template&id=68ceec4c&", function () {
      api.rerender('68ceec4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/projects/Projects.vue"
export default component.exports